import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";

import { Button } from "@material-ui/core";
import { CsvBuilder } from "filefy";
import sort from "fast-sort";

import _ from "lodash";

import { formatSecondsForDate } from "../../layout/utils/timeUtils";
import colors from "../../styles/colors";

const styles = {
  darkRow: {
    backgroundColor: colors.dirtyWhite,
  },
  lightRow: {
    backgroundColor: colors.white,
  },
};

export default (props) => {
  const [patient, setPatient] = useState();

  const download = () => {
    const rows = [];
    props.reportData.map((e) => {
      rows.push([
        e.lastName,
        e.firstName,
        e.email,
        e.totalPoints,
        e.date
          ? new Date(e.date.year, e.date.day, e.date.month).toLocaleDateString()
          : "",
        e.instruction,
      ]);
      return null;
    });

    const date = new Date();
    const builder = new CsvBuilder(
      "patient_pts_report" + date.toLocaleDateString() + ".csv"
    );
    builder
      .setDelimeter(",")
      .setColumns([
        "LastName",
        "FirstName",
        "Email",
        "Total Points",
        "ActivityDate",
        "Activity",
      ])
      .addRows(rows)
      .exportFile();
  };

  const patientSelected = () => {};

  const renderPatientSelect = () => {};

  return !_.isEmpty(props.reportData) && props.reportData.length > 0 ? (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <FormControl>
          <InputLabel id="">Patient Filter</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={patient}
            onChange={patientSelected}
          >
            {props.reportData &&
              props.reportData.map((row) => {
                if (row.firstName) {
                  return (
                    <MenuItem value={row.userId}>
                      {row.firstName + " " + row.lastName}
                    </MenuItem>
                  );
                } else {
                  return null;
                }
              })}
          </Select>
          <FormHelperText>Select A Patient To Filter The Report</FormHelperText>
        </FormControl>
        <Button
          variant="outlined"
          color="primary"
          disabled={_.isEmpty(props.reportData) || props.reportData.length < 1}
          onClick={download}
          style={{ padding: 5, margin: 5 }}
        >
          Download Report
        </Button>
      </div>
      <Paper elevation={5} style={{ padding: 30 }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: "#F2F2F2" }}>
                <TableCell>Last Name</TableCell>
                <TableCell>First Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell align="center">Total Points</TableCell>
                <TableCell align="center">Activity Date</TableCell>
                <TableCell align="center">Activity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.reportData &&
                props.reportData.map((row) => {
                  return (
                    <TableRow
                      key={row.lastName}
                      style={row.lastName ? styles.darkRow : styles.lightRow}
                    >
                      <TableCell component="th" scope="row">
                        {row.lastName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.firstName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.email}
                      </TableCell>
                      <TableCell align="center">{row.totalPoints}</TableCell>
                      <TableCell align="center">
                        {row.date &&
                          new Date(
                            row.date.year,
                            row.date.day,
                            row.date.month
                          ).toLocaleDateString()}
                      </TableCell>
                      <TableCell align="left">{row.instruction}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  ) : (
    <h3>{props.msg}</h3>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/PatientComplianceReport.js